import { MESSAGE_ATTACHMENT_MAX_COUNT, toFileAttachment } from '~/lib/messageAttachments';
import type { FileAttachment, UploadedFile } from '~/types/models';

export function normalizeApprovalAttachments(value: unknown): FileAttachment[] {
    if (!Array.isArray(value)) return [];

    const seen = new Set<string>();
    const normalized: FileAttachment[] = [];
    for (const entry of value) {
        if (!entry || typeof entry !== 'object') continue;
        const attachment = entry as Partial<FileAttachment>;
        const fileId = String(attachment.fileId || '').trim();
        const fileName = String(attachment.fileName || '').trim();
        const fileURL = String(attachment.fileURL || '').trim();
        const storagePath = String(attachment.storagePath || '').trim();
        if (!fileId || !fileName || !fileURL || !storagePath || seen.has(fileId)) continue;

        seen.add(fileId);
        normalized.push({
            fileId,
            fileName,
            fileURL,
            storagePath,
            ...(attachment.contentType ? { contentType: String(attachment.contentType) } : {}),
            ...(Number.isFinite(Number(attachment.sizeBytes)) ? { sizeBytes: Number(attachment.sizeBytes) } : {}),
        });
        if (normalized.length === MESSAGE_ATTACHMENT_MAX_COUNT) break;
    }

    return normalized;
}

export function resolveStoredApprovalAttachments(
    requested: unknown,
    storedFiles: UploadedFile[],
    projectId: string,
): FileAttachment[] {
    const storedById = new Map(storedFiles
        .filter((file) => file.entityType === 'project' && file.entityId === projectId)
        .map((file) => [file.id, file]));

    return normalizeApprovalAttachments(requested)
        .map((attachment) => storedById.get(attachment.fileId))
        .filter((file): file is UploadedFile => Boolean(file))
        .map(toFileAttachment);
}
